import { defineStore } from 'pinia';
import axios from 'axios';
import { useNotificationStore } from '@/store/global/notification';

export const useUrlsStore = defineStore('topUrls', {
	state: () => ({
		loading: false,
		tableUrl: [],
		marketQuestions: [],
	}),
	getters: {},
	actions: {
		async fetchMarketQuestions(marketId) {
			const { data } = await axios.post(
				'vuejs/get_market_questions',
				{ market_id: marketId },
				{ withCredentials: true }
			);
			this.marketQuestions = data?.data || [];
			return this.marketQuestions;
		},
		async assignQuestionToUrl(marketId, url, questionId) {
			await axios.post(
				'vuejs/assign_question_to_url',
				{ market_id: marketId, url, question_id: questionId },
				{ withCredentials: true }
			);
		},
		async removeQuestionFromUrl(marketId, url, questionId) {
			await axios.post(
				'vuejs/remove_question_from_url',
				{ market_id: marketId, url, question_id: questionId },
				{ withCredentials: true }
			);
		},
		async fetchData(marketId) {
			this.loading = true;

			// Try to fetch selected dates from localStorage
			const selected_dates = JSON.parse(localStorage.getItem('visibilitySelectedDates'));

			let startDate, endDate, date_from, date_to;

			if (selected_dates && selected_dates.from && selected_dates.to) {
				// TODO: change this because if visibilitySelectedDates is not set, it will not work and make error in the console with selected_dates.from
				const selected_dates = JSON.parse(localStorage.getItem('visibilitySelectedDates'));

				date_from = selected_dates.from;
				date_to = selected_dates.to;
			} else {
				// If selected_dates do not exist, set new dates
				endDate = new Date(); // Today's date
				startDate = new Date(endDate.getTime() - 7 * 24 * 60 * 60 * 1000); // 7 days before today

				date_from = startDate.toISOString().substring(0, 10).split('-');
				date_to = endDate.toISOString().substring(0, 10).split('-');

				date_from = date_from[2] + '-' + date_from[1] + '-' + date_from[0];
				date_to = date_to[2] + '-' + date_to[1] + '-' + date_to[0];
			}

			// Extract and format the day, month, and year for startDate and endDate
			const [urlsResponse] = await Promise.all([
				axios.post(
					'vuejs/get_top_urls',
					{
						market_id: marketId,
						date_range_start: date_from,
						date_range_end: date_to,
					},
					{ withCredentials: true },
				),
				this.fetchMarketQuestions(marketId),
			]);

			this.loading = false;
			this.tableUrl = urlsResponse.data?.data || urlsResponse.data || [];
		},
	},
});
